import React, {useContext} from 'react'
/* --------------------------------------------- */
import { useHistory } from 'react-router-dom'
/* --------------------------------------------- */
import Button from "../../../form/Button"
import { InfoTitle, InfoDesc, ButtonWrapper, InfoCtaDesc } from '../styles'
import "../_landing-page.scss";
import "./_page-type.scss";
import { GlobalContext } from '../../../../context/global.context'
import { useSelector } from 'react-redux';

/* --------------------------------------------- */
// FAQ component for showing pageComponent
const FAQ = (props) => {
  // const { graphics } = theme
  // const [theme, updateTheme] = useState(null)
  const { sectionData, contentData, themeSection: theme = {} } = props
  const componentData = sectionData
  const { ctaAction, ctaLink } = componentData
  const history = useHistory()
  const { dispatch } = useContext(GlobalContext)
  const { userManagementConfig = {} } = useSelector(store => store.userManagement)
  /* --------------------------------------------- */
  const { loginMethods = [] } = userManagementConfig
  // const { appTheme } = useSelector(store => store.themeConfigReducers)

  /**
   * It: Updates theme.
   */
  // useEffect(() => {
  //   updateTheme(appTheme)
  // }, [appTheme])

  const scroll = (id) => {
    const element = document.getElementById(id)
    const scrollPosition = element.offsetTop - 160 // to remove extra spacing frm specific div
    window.scrollTo({
      top: scrollPosition,
      behavior: 'smooth'
    })
  }
   
  const onclick = () => {
    if (ctaAction === 'sectionNavigation' && ctaLink && ctaLink.length) {
      const [link] = ctaLink
      const id = link.sys.id
      scroll(id)
    } else if (ctaAction === 'externalNavigation') {
      // Not implemented yet
      window.location.href = ''
    } else {
    // default behaviour
      dispatch({ type: 'RENDERED_LANDING', value: true })
      if ((loginMethods || []).indexOf('vdt') > -1) {
        dispatch({ type: 'SHOW_LOGIN_POPUP' })
        dispatch({
          type: 'LOGIN_POPUP_DETAILS',
          value: {
            isShowCloseIcon: true,
            onCloseClick: () => {
              dispatch({ type: 'HIDE_LOGIN_POPUP' })
            }
          }
        })
      } else {
        history.push('/SignUp')
      }
    }
  }

  const ctaDataInfo = (
    <div style={{textAlign: 'center', paddingTop: '40px'}}>
      {
        componentData.ctaDescription && (
          <InfoCtaDesc {...{ theme }} className='infoSection__ctadesc font18'>{componentData.ctaDescription}</InfoCtaDesc>
        )
      }
      {
        componentData.ctaData && (
          <ButtonWrapper {...{ theme }}>
            <Button {...{ title: componentData.ctaData }} onClick={onclick} />
          </ButtonWrapper>
        )
      }
    </div>
  )

  return (
    <>
      <div className="faq-component">
        {
          contentData.map((data, idx) => {
            const {title, description} = data
            return (
              <div className="faq-section" key={idx}>
                {
                  title && (
                    <InfoTitle {...{ theme }} className='infoSection__title'>{title}</InfoTitle>
                  )
                }
                {
                  description && (
                    <InfoDesc {...{ theme }} className='infoSection__desc infoSection__label'>{description}</InfoDesc>
                  )
                }
              </div>
            )
          })
        }
      </div>
      {ctaDataInfo}
    </>
  )
}


/* --------------------------------------------- */
FAQ.propTypes = {

}
/* --------------------------------------------- */
FAQ.defaultProps = {

}
/* --------------------------------------------- */
export default FAQ
